<template>
    <div>
        <table-error-history-user v-if="tableError" :responseError="tableError"></table-error-history-user>
        <div v-if="!tableError" style="display: flex; flex-direction: column; gap: 20px">
            <div style="display: flex; flex-direction: column">
                <label>Bước 1: Tải xuống file mẫu</label>
                <button class="btn btn-primary" style="width: 130px" @click="downloadFileExcelExample">
                    <i class="el-icon-bottom" style="color: white"></i>
                    Tải xuống
                </button>
            </div>
            <div style="display: flex; flex-direction: column">
                <label>Bước 2: Tải file excel lên hệ thống</label>
                <div class="mb-2">
                    <el-upload
                        ref="upload"
                        accept=".xlsx"
                        :limit="1"
                        list-type="text"
                        action=""
                        :file-list="fileList"
                        :on-change="handleChange"
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        :multiple="false"
                    >
                        <el-button size="small" type="warning">
                            <i class="el-icon-upload2"></i>
                            Tải lên
                        </el-button>
                    </el-upload>
                </div>
            </div>
        </div>
        <div style="display: flex;justify-content: flex-end; align-items: center; gap: 20px">
            <button class="btn" style="background: #CACACA" @click="closeDialog">Hủy bỏ</button>
            <el-button v-if="!tableError" v-loading="disableImport" :disabled="disableImport"
                       class="btn btn-primary text-white" style="background: #5D04B0" @click="handleImportFileExcel">Xác
                nhận
            </el-button>
            <button
                v-if="tableError"
                class="btn btn-primary text-white"
                style="background: #5D04B0"
                @click="backToImport"
            >Quay lại
            </button>
        </div>
    </div>
</template>

<script>
import {IMPORT_FILE_EXCEL_KRA, PREVIEW_FILE_EXCEL_KRA} from "@/core/services/store/user/users.module";
import {ImportKraModel} from "@/view/pages/user/model/ImportKraModel";
import {EXPORT_SAMPLE_FILE_HISTORY_USER, IMPORT_HISTORY_USER} from "../../../../core/services/store/user/users.module";
import {read, utils} from "xlsx";
import TableErrorHistoryUser from "./TableErrorHistoryUser";

export default {
    name: "DialogHistoryUser",
    components: {TableErrorHistoryUser},
    data() {
        return {
            fileList: [],
            dataImport: [],
            tableError: false,
            listErrors: [],
            disableImport: false,
        }
    },
    mounted() {
    },
    methods: {
        downloadFileExcelExample() {
            this.$store.dispatch(EXPORT_SAMPLE_FILE_HISTORY_USER).then((res) => {
                this.$notify({
                    title: 'Thành công',
                    message: res.message,
                    type: 'success'
                })
            }).catch((error) => {
                this.$notify({
                    title: 'Thất bại',
                    message: error.data.message,
                    type: 'error'
                })
            })
        },
        closeDialog() {
            this.$emit('closeDialog');
            this.$emit('setTitleError', 'Import kra')
            this.listErrors = []
            this.fileImport = null
            this.tableError = false
            this.disableImport = false
        },
        backToImport() {
            this.fileImport = null
            this.tableError = false
            this.disableImport = false
            this.listErrors = []
            this.$emit('setTitleError', 'Import kra')
        },
        handleChange(file, fileList) {
            this.fileList = fileList
        },
        handleRemove() {
            this.fileList = []
        },
        fileToJson(file) {
            return new Promise((res, rej) => {
                /* Boilerplate to set up FileReader */
                const reader = new FileReader()
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result
                    const wb = read(bstr, {type: 'binary'})
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0]
                    const ws = wb.Sheets[wsname]
                    /* Convert array of arrays */
                    const data = utils.sheet_to_json(ws, { defval: '' })

                    res(data);
                }
                reader.onerror = (e) => {
                    rej(e);
                };
                reader.readAsBinaryString(file[0].raw)
            });
        },
        async handleImportFileExcel() {
            this.disableImport = true
            if (!this.fileList) {
                this.$notify({
                    title: 'Thất bại',
                    message: 'Chưa có file nào được chọn',
                    type: 'error'
                });
                return
            }

            this.fileToJson(this.fileList).then(dataToImport => {
                 this.$store.dispatch(IMPORT_HISTORY_USER, dataToImport).then(res => {
                     console.log(res?.error, 'this.tableError')

                     if (!res?.error) {
                        this.$message.error('Import thanh công !')
                        return;
                    }
                    this.tableError = res.data;
                }).catch(e => {
                     this.tableError = this.normalizeKeys(e.data.data.data);
                     console.log(this.tableError, 'Import thất bại')
                     this.$message.error('Import thất bại')
                 })
            })
        },
        normalizeKeys(obj) {
            const newObj = {};
            for (const key in obj) {
                // thay / hoặc \ thành _
                const newKey = key.replace(/[\/\\]/g, "_");
                newObj[newKey] = obj[key];
            }
            return newObj;
        }
    }
}
</script>